export const CONTINUOUS_LISTENING_PLAYLIST_ID = "continuous_listening";
export const EXPLORE_FEED_PLAYLIST_ID = "explore_feed";

export const APP_ONLY_PLAYLIST_IDS = [
  CONTINUOUS_LISTENING_PLAYLIST_ID,
  EXPLORE_FEED_PLAYLIST_ID,
];

type PlaylistIdentity = {
  id: string;
  user?: { id?: string | null } | null;
};

type PlaylistWithSongIds = PlaylistIdentity & {
  songIds: readonly string[];
};

export const isLikedSongsPlaylist = ({ id }: Pick<PlaylistIdentity, "id">) =>
  id.startsWith("liked_");

export const isUserSaveDestination = (
  playlist: PlaylistIdentity,
  userId?: string | null,
) =>
  isLikedSongsPlaylist(playlist) ||
  (!!userId && playlist.user?.id === userId);

export const isSongSavedInUserPlaylists = (
  playlists: readonly PlaylistWithSongIds[] | null | undefined,
  songId: string,
  userId?: string | null,
) =>
  !!playlists?.some(
    (playlist) =>
      isUserSaveDestination(playlist, userId) &&
      playlist.songIds.includes(songId),
  );

export const compareLikedSongsFirst = (
  a: Pick<PlaylistIdentity, "id">,
  b: Pick<PlaylistIdentity, "id">,
) =>
  Number(isLikedSongsPlaylist(b)) - Number(isLikedSongsPlaylist(a));
